import React from 'react';
import {GenericError} from './GenericError';
import {ViewBase} from '../../../patterns/views/base';
import * as Sentry from '@sentry/react';

interface ErrorBoundaryProps {
    children: React.ReactNode;
    standalone?: boolean;
}

export const ErrorBoundary = (props: ErrorBoundaryProps): JSX.Element => (
    <Sentry.ErrorBoundary fallback={props.standalone ? <GenericError/> : <ViewBase><GenericError/></ViewBase> }>
        {props.children}
    </Sentry.ErrorBoundary>
);
